
import React from 'react';
import { Dealer } from '@/types/dealer';
import { MapPlaceholder } from './map/MapPlaceholder';
import { useGeolocation } from '@/hooks/useGeolocation';
import { Button } from '@/components/ui/button';
import { MapPin, RefreshCw } from 'lucide-react';

interface DealersMapProps {
  dealers: Dealer[];
  height?: string;
  className?: string;
}

export function DealersMap({ 
  dealers,
  height = '500px',
  className = '' 
}: DealersMapProps) {
  const { position, error, loading, getCurrentPosition } = useGeolocation({
    enableHighAccuracy: true,
    timeout: 10000,
    maximumAge: 300000, // 5 minutes
  });

  console.log('🗺️ DealersMap render:', {
    dealersCount: dealers.length,
    userPosition: position ? {
      lat: position.coords.latitude,
      lng: position.coords.longitude,
      accuracy: position.coords.accuracy
    } : null,
    error: error?.message,
    loading
  });

  return (
    <div className={`relative ${className}`}>
      {/* Geolocation Status and Controls */}
      <div className="mb-4 flex flex-col sm:flex-row gap-2 items-start sm:items-center justify-between">
        <div className="flex items-center gap-2">
          <MapPin className="h-4 w-4 text-muted-foreground" />
          <span className="text-sm text-muted-foreground">
            {loading && "Rilevamento posizione..."}
            {error && `Errore posizione: ${error.message}`}
            {position && !loading && "Posizione rilevata"}
            {!position && !loading && !error && "Posizione non disponibile"}
          </span>
        </div>
        
        <Button
          variant="outline"
          size="sm"
          onClick={getCurrentPosition}
          disabled={loading}
          className="flex items-center gap-2"
        >
          <RefreshCw className={`h-4 w-4 ${loading ? 'animate-spin' : ''}`} />
          {loading ? 'Rilevamento...' : 'Rileva posizione'}
        </Button>
      </div>

      {/* Map Component */}
      <div className="rounded-lg overflow-hidden border">
        <MapPlaceholder
          dealers={dealers}
          userPosition={position}
          height={height}
          width="100%"
          zoom={position ? 14 : 10}
          className="w-full"
        />
      </div>

      {/* Map Info */}
      <div className="mt-2 text-xs text-muted-foreground">
        {dealers.length > 0 && (
          <span>
            Visualizzati {dealers.length} compro oro
            {position && " • Mappa centrata sulla tua posizione"}
          </span>
        )}
      </div>
    </div>
  );
}
